export enum BillingCycleEnum {
    Weekly = 1,
    BiWeekly = 2,
    FourWeekly = 3,
    Monthly = 4,
    Annual = 5,
    Pay_In_Full = 6,
    Quarterly = 7,
    HalfYearly = 8,
    PerVisit = 9,
    Biennial = 10
}